export { default } from './ButtonAddToWishlist';
